import { useRouter } from 'expo-router'
import type { ReactNode } from 'react'

import { Button } from '@/src/elements/button/default'
import { ICON } from '@/src/general/enums/icons'
import { useRoutes } from '@/src/general/utils/routes'

import type { TCommunityApiRoleInfos, TSmallCommunityApi } from '../../../../api/communityApi.types'

export type TCommunityAdminButtonProps = TCommunityApiRoleInfos &
  Pick<TSmallCommunityApi, 'id' | 'slug'> & { onPress?: () => void; testID?: string }

export const CommunityAdminButton = ({ id, slug, onPress, ...rest }: TCommunityAdminButtonProps): ReactNode => {
  const { push } = useRouter()
  const { routes } = useRoutes()
  const defaultOnPress = () => push(routes.communityAdmin({ id, slug }))

  return (
    <Button
      size="md"
      colors="secondary"
      variant="faded"
      startIcon={ICON.PENCIL}
      isIconOnly
      onPress={onPress ?? defaultOnPress}
      role={'link'}
      {...rest}
    />
  )
}
